// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/mutation_edit_payment_plan.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_TreatmentCard_PaymentsTreatmentPlan_Content_TreatmentPayments(
  $payment_plan_id: numeric!
  $token: jsonb!
  $is_fee_acknowledged: Boolean!
) {
  payments_add_payment_plan_autopay(
    payment_plan_id: $payment_plan_id
    token: $token
    is_fee_acknowledged: $is_fee_acknowledged
  ) {
    payment_plan_id
    verified
    verification_metadata
  }
}

`